import { render } from "./VnRules.vue?vue&type=template&id=c20d323c&scoped=true"
import script from "./VnRules.vue?vue&type=script&scoped=true&lang=js"
export * from "./VnRules.vue?vue&type=script&scoped=true&lang=js"

import "./VnRules.vue?vue&type=style&index=0&id=c20d323c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c20d323c"

export default script